module.exports = __webpack_public_path__ + "media/images/emblems/PlanLesOuates-coat_of_arms-86c20464f0634563a2fae83c3d300278.svg";